import * as yup from "yup";
import i18n from "../../../i18n";
import {isInvoicePeriodRequired} from "../../../constants/constants";

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const min5LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 5});
const max500LengthsMessage = () => i18n.t("validation.maxLength", {ns: "common", max: 500});

export const updateSubCompanyValidation = yup.object().shape({
    name: yup.string().required(requiredMessage),
    address: yup
        .string()
        .min(5, min5LengthsMessage)
        .max(500, max500LengthsMessage)
        .required(requiredMessage),
    location: yup.object().shape({
        longitude: yup.number().required(requiredMessage),
        latitude: yup.number().required(requiredMessage)
    }),
    uniqueKey: yup.string(),
    creditMode: yup.string().nullable(),
    invoicePeriod: yup
        .string()
        .nullable()
        .when("creditMode", {
            is: isInvoicePeriodRequired,
            then: yup.string().nullable().required(requiredMessage)
        }),
    city: yup.string(),
    county: yup.string().when("city", {
        is: city => !!city,
        then: yup.string().required(requiredMessage),
        otherwise: yup.string(),
    }),
    district: yup.string().when("county", {
        is: county => !!county,
        then: yup.string().required(requiredMessage),
        otherwise: yup.string(),
    }),
});
